import Box from '@mui/material/Box';
import { FeaturedTrialType } from '../../components/shared/Carousel/Carousel.types';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const FALLBACK_HEIGHTS = {
  mobileOrTablet: 640,
  desktop: 690,
} as const;

const getFallbackHeight = (isMobile: boolean, isBelowDesktop: boolean) =>
  isMobile || isBelowDesktop ? FALLBACK_HEIGHTS.mobileOrTablet : FALLBACK_HEIGHTS.desktop;

const getVerticalPadding = (isMobile: boolean) => (isMobile ? 64 : 96);

const FeaturedTrial = (props: FeaturedTrialType): JSX.Element => {
  const featuredTrialElement = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [measuredHeight, setMeasuredHeight] = useState<number | null>(null);
  const enableFilterChip = props.fields?.enableFilterChip?.value;
  const isNotificationBannerOpen = useSelector(
    (state: RootState) => state.config.isNotificationBannerOpen
  );

  const theme = useTheme();

  const isBelowDesktop = useMediaQuery(theme.breakpoints.down('lg'));

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (featuredTrialElement && featuredTrialElement.current && !isBelowDesktop) {
      const bannerElement = document.getElementById('notification-banner');

      let bannerHeight = 0;

      if (bannerElement) {
        bannerHeight = bannerElement.offsetHeight;
      }

      featuredTrialElement.current.style.marginTop = `${bannerHeight}px`;
    }
  }, [isNotificationBannerOpen, isBelowDesktop]);

  useEffect(() => {
    const contentElement = contentRef.current;

    if (!contentElement) {
      return;
    }

    const measure = () => {
      const contentHeight = contentElement.scrollHeight;

      if (contentHeight > 0) {
        const verticalPadding = getVerticalPadding(isMobile);
        setMeasuredHeight(contentHeight + verticalPadding);
      } else {
        setMeasuredHeight(null);
      }
    };

    measure();

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(contentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [isMobile, isBelowDesktop, isNotificationBannerOpen]);

  if (!props.fields) {
    return <></>;
  }

  const fallbackHeight = getFallbackHeight(isMobile, isBelowDesktop);
  const height =
    enableFilterChip && measuredHeight && measuredHeight > 0 ? measuredHeight : fallbackHeight;

  return (
    <Box
      ref={featuredTrialElement}
      id="featured-trial"
      sx={{
        padding: isMobile ? '24px 8px 16px 8px' : '48px 8px',

        height: `${height}px !important`,

        top: props?.fields?.top?.value || 290,
      }}
    >
      <Box ref={contentRef}>
        <CarouselWrapper
          {...props}
          identifier="featured-trials-carousal"
          callerComponent="FeaturedTrials"
        />
      </Box>
    </Box>
  );
};

export default FeaturedTrial;
